import { useRef } from 'react';

import cx from 'classnames';
import { Link } from 'components/router';

import type { Topic } from 'api';
import type TopicsListProps from './TopicsList.props';

const TopicsList = ({
  className,
  topics
}: TopicsListProps): React.ReactNode => {
  const linkRef = useRef<HTMLAnchorElement>(null);

  return (
    <ul className={cx('mb-6 inline-block', className)}>
      {topics.map((topic: Topic) => {
        // Skip topics without name or slug
        if (!topic.name || !topic.slug) return null;

        return (
          <li
            key={topic.slug}
            className="mr-2 inline-block after:content-[','] last:mr-0 last:after:content-['_']"
          >
            <Link
              ref={linkRef as React.RefObject<HTMLAnchorElement | null>}
              href={`/topics/${topic.slug}`}
              className="inline-block py-1 text-tui-sm capitalize underline"
            >
              {topic.name}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default TopicsList;
